module.exports = __webpack_public_path__ + "static/media/dep6.b0dba619.jpg";